const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "60px",
    width: "60px",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M447.703,512H109.215c-7.723,0-13.984-6.262-13.984-13.984V40.094  c0-7.722,6.261-13.984,13.984-13.984h338.488c20.244,0,36.713,16.468,36.713,36.711v229.533c0,7.722-6.262,13.984-13.984,13.984  c-7.722,0-13.984-6.262-13.984-13.984V62.821c0-4.82-3.923-8.743-8.744-8.743H123.199v429.953h324.504  c4.822,0,8.744-3.923,8.744-8.744V368.701c0-7.722,6.262-13.984,13.984-13.984c7.722,0,13.984,6.262,13.984,13.984v106.586  C484.415,495.531,467.946,512,447.703,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFF09E"
    },
    d: "M129.546,497.929H75.274c-18.613,0-33.703-15.089-33.703-33.703V73.711  c0-18.613,15.089-33.703,33.703-33.703h54.273V497.929z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M129.546,511.913H75.272c-26.295,0-47.688-21.393-47.688-47.688V73.711   c0-26.295,21.392-47.688,47.688-47.688h54.274c7.723,0,13.984,6.262,13.984,13.984v457.922   C143.531,505.653,137.27,511.913,129.546,511.913z M75.272,53.992c-10.873,0-19.719,8.845-19.719,19.719v390.516   c0,10.873,8.846,19.719,19.719,19.719h40.29V53.992H75.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M213.791,337.476c-1.412,2.39-3.584,3.151-5.648,3.151c-1.955,0-4.018-0.652-5.321-3.151   l-10.318-18.895v41.813c0,3.474-4.234,5.212-8.47,5.212s-8.472-1.738-8.472-5.212v-65.706c0-6.191,4.236-8.472,8.472-8.472   c6.082,0,8.688,0.652,13.141,8.472l11.186,19.549l11.186-19.549c4.453-7.82,7.059-8.472,13.141-8.472   c4.343,0,8.47,2.281,8.47,8.472v65.706c0,3.474-4.234,5.212-8.47,5.212c-4.236,0-8.472-1.738-8.472-5.212v-40.728L213.791,337.476z   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M247.458,358.655c0-0.326,0.108-0.761,0.217-1.194l20.2-66.249   c1.196-3.802,6.083-5.648,11.078-5.648c4.995,0,9.881,1.846,11.077,5.648l20.308,66.249c0.109,0.434,0.218,0.868,0.218,1.194   c0,4.018-6.191,6.95-10.86,6.95c-2.714,0-4.887-0.87-5.539-3.149l-3.693-13.576h-22.916l-3.693,13.576   c-0.652,2.279-2.823,3.149-5.539,3.149C253.649,365.605,247.458,362.672,247.458,358.655z M286.883,335.848l-7.928-29.105   l-7.929,29.105H286.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M357.042,286.215c3.584,0,5.104,3.91,5.104,7.493c0,4.128-1.847,7.711-5.104,7.711h-14.987v58.973   c0,3.474-4.234,5.212-8.47,5.212c-4.236,0-8.472-1.738-8.472-5.212v-58.973h-14.988c-3.258,0-5.103-3.583-5.103-7.711   c0-3.583,1.52-7.493,5.103-7.493H357.042L357.042,286.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M407.434,330.96h-21.613v29.433c0,3.474-4.236,5.212-8.472,5.212s-8.47-1.738-8.47-5.212v-69.072   c0-3.584,4.234-5.104,8.47-5.104s8.472,1.52,8.472,5.104v26.608h21.613v-26.608c0-3.584,4.236-5.104,8.472-5.104   c4.236,0,8.472,1.52,8.472,5.104v69.072c0,3.474-4.236,5.212-8.472,5.212c-4.236,0-8.472-1.738-8.472-5.212V330.96z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFF09E"
    },
    d: "M317.075,13.984v156.097c0,3.026,3.205,4.978,5.894,3.588l41.307-21.343  c1.163-0.601,2.545-0.601,3.709,0l41.307,21.343c2.689,1.389,5.894-0.562,5.894-3.588V13.984H317.075z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M411.142,188.111c0,0-0.001,0-0.003,0c-2.858,0-5.72-0.698-8.273-2.018l-36.738-18.982   l-36.742,18.982c-2.551,1.319-5.412,2.017-8.272,2.017c-9.939,0-18.026-8.087-18.026-18.028V13.984   C303.089,6.262,309.351,0,317.073,0h98.109c7.722,0,13.984,6.262,13.984,13.984v156.099c0,4.945-1.956,9.553-5.511,12.975   C420.271,186.316,415.827,188.111,411.142,188.111z M331.057,27.968v125.781l26.798-13.844c5.086-2.63,11.454-2.632,16.549,0.001   l26.794,13.843V27.968H331.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M378.367,251.232H224.541c-7.723,0-13.984-6.262-13.984-13.984c0-7.722,6.261-13.984,13.984-13.984   h153.826c7.722,0,13.984,6.262,13.984,13.984C392.352,244.97,386.091,251.232,378.367,251.232z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMath);
export default __webpack_public_path__ + "static/media/math.ab203d84b51e55e74be00455bd7a08e7.svg";
export { ForwardRef as ReactComponent };